export default "__VITE_ASSET__BGOHcIbs__"